{
  "zh-CN": {
    "nav": {
      "home": "主页",
      "back": "返回",
      "navigation": "导航",
      "ships": {
        "index": "飞船"
      },
      "compare": {
        "index": "比较",
        "ships": "比较飞船"
      },
      "manufacturers": "制造商",
      "images": "图片",
      "videos": "视频",
      "hangar": {
        "index": "我的机库",
        "vehicleLoadouts": "Loadouts"
      },
      "login": "登录",
      "logout": "登出",
      "apiV1": "API v1",
      "apiV1Schema": "架构",
      "apiV1Pagination": "分页",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "架构",
      "embed": "嵌入小部件",
      "signUp": "注册",
      "privacyPolicy": "隐私政策",
      "impressum": "法律声明",
      "fleets": {
        "index": "舰队",
        "add": "创建新舰队",
        "invites": "邀请",
        "ships": "飞船",
        "members": {
          "index": "Members",
          "invites": "Invites",
          "worldmap": "世界地图",
          "starmap": "星图"
        },
        "stats": "统计",
        "logistics": {
          "index": "Logistics"
        },
        "settings": {
          "index": "设置",
          "fleet": "舰队设置",
          "membership": "成员设置",
          "roles": "角色"
        }
      },
      "rsiProfile": "RSI 档案",
      "rsiHangar": "RSI 机库",
      "tools": {
        "index": "工具",
        "travelTimes": "旅行时间",
        "cargoGrids": "货物网格"
      },
      "api": "API 文档",
      "stats": "统计",
      "toggleSlimCollapse": "折叠",
      "toggleSlimExpand": "展开",
      "roadmap": {
        "index": "路线图",
        "overview": "概览",
        "changes": "变更",
        "ships": "飞船路线图"
      },
      "rsiVerification": "RSI 验证",
      "settings": {
        "index": "设置",
        "profile": "档案",
        "account": "账户",
        "security": "安全",
        "notifications": "通知",
        "hangar": "机库",
        "features": "功能",
        "connections": "连接",
        "oauthApplications": "OAuth 应用",
        "verify": "RSI 账户验证"
      },
      "reload": "有可用更新！",
      "visualTests": {
        "index": "视觉测试",
        "panels": "面板",
        "buttons": "按钮",
        "tables": "表格",
        "notifications": "通知",
        "syncModal": "同步弹窗",
        "supportHint": "支持提示"
      },
      "admin": {
        "index": "管理员",
        "models": {
          "index": "模型",
          "create": "创建模型",
          "edit": {
            "index": "基础数据",
            "metrics": "指标",
            "prices": "价格",
            "docks": "停靠点",
            "modules": "模块",
            "paints": "涂装",
            "images": "图片",
            "videos": "视频",
            "cargoAndFuel": "货物和燃料",
            "cargoHolds": "货舱",
            "fleetchart": "舰队图表图片",
            "hardpoints": "武器挂点",
            "loaners": "借用船",
            "upgrades": "升级",
            "packages": "套餐"
          }
        },
        "modelPaints": {
          "index": "涂装",
          "create": "创建涂装"
        },
        "modelModules": {
          "index": "模块",
          "create": "创建模块",
          "edit": {
            "index": "基本数据",
            "models": "模型",
            "prices": "价格"
          }
        },
        "modelModulePackages": {
          "index": "模块包",
          "create": "创建模块包"
        },
        "components": {
          "index": "组件",
          "edit": {
            "index": "基础数据",
            "prices": "价格"
          }
        },
        "manufacturers": {
          "index": "制造商"
        },
        "images": {
          "index": "图片"
        },
        "users": {
          "index": "用户"
        },
        "fleets": {
          "index": "舰队"
        },
        "vehicles": {
          "index": "载具"
        },
        "admins": {
          "index": "管理员"
        },
        "oauthApplications": {
          "index": "OAuth 应用"
        },
        "maintenance": {
          "index": "维护",
          "pghero": "PG-Hero",
          "features": "功能",
          "workers": "工作进程",
          "tasks": "任务",
          "rsiApiStatus": "RSI API 状态"
        },
        "supporterContributions": {
          "index": "支持者贡献",
          "new": "新建支持者贡献",
          "edit": "编辑支持者贡献"
        },
        "fundingGoals": {
          "index": "资金目标",
          "new": "新建资金目标",
          "edit": "编辑资金目标"
        }
      }
    }
  }
}
